<div class="zones-container-label" *ngIf="showLabel" data-testid="container"
     [class]="{'zones-container-label--full-width': fullWidth }">
    <div class="zones-container-label__inner">
        <div class="zones-container-tile__icon--small"
             *ngIf="details.duringChange">
            <loader></loader>
        </div>
        <div class="zones-container-label__name">
            {{ details.duringChange ? subtitle(3162) : details.containerName }}
        </div>
    </div>

    <div class="zones-container-label__inner zones-container-label__inner--alert"
         *ngIf="details.parameters.signal === -3">
        <div class="zones-container-label__icon bg-cancel">
            <img class="zones-container-tile__icon"
                 data-testid="no-signal-icon"
                 *ngIf="details.parameters.signal === -3"
                 ngSrc="/assets/img/id_icons/122.svg"
                 width="36" height="36" alt=""/>
        </div>
        <floating-subtitle class="zones-container-label__alert"
                           [text]="subtitle(1808)">
        </floating-subtitle>
    </div>

    <div class="zones-container-label__arrow-icon-wrapper"
         data-testid="container-arrow"
         (click)="toggleContainer()">
        <img class="zones-container-label__arrow-icon cursor-pointer"
             *ngIf="!(fullWidth && details.parameters.signal === -3)"
             ngSrc="/assets/img/icons/drop-down-arrow.svg"
             [class]="{ 'zones-container-label__arrow-icon--rotate': showZones }"
             width="20" height="20" alt=""/>
    </div>
</div>
<div class="zones-container" *ngIf="showZones">
    <ng-content></ng-content>
</div>
